import { PendingDocumentMove } from "../../api/ClientFileApi";

interface PendingMovesFormValues {
  documentMoves: PendingDocumentMove[];
}

/** The subset of the Formik bag the handlers need — any form whose values carry `documentMoves`. */
interface PendingMovesFormik<Values extends PendingMovesFormValues> {
  values: Values;
  setFieldValue: (field: string, value: unknown) => Promise<unknown>;
}

/**
 * Add/cancel handlers for a form's pending document moves (`documentMoves` field), shared by
 * every asset inventory view that defers drag-moves to save. Adding silently ignores a document
 * that already has a pending move; cancelling removes the document's move.
 */
export function usePendingMovesField<Values extends PendingMovesFormValues>(formik: PendingMovesFormik<Values>) {
  const onAddMove = (move: PendingDocumentMove) => {
    const moves = formik.values.documentMoves;
    if (moves.some((m) => m.document.documentId === move.document.documentId)) {
      return;
    }
    void formik.setFieldValue("documentMoves", [...moves, move]);
  };

  const onCancelMove = (documentId: string) => {
    void formik.setFieldValue(
      "documentMoves",
      formik.values.documentMoves.filter((m) => m.document.documentId !== documentId)
    );
  };

  return { onAddMove, onCancelMove };
}
